require("./contractPayrollLoanView.scss");

const PropTypes = require("prop-types");

// @vendor
const React = require("react");
const { connect } = require("react-redux");

// @common
const { OKCover } = require("commonsComponents/OKCover");
const { OKHeaderSubPage } = require("commonsComponents/OKHeaderSubPage");

// @components
const ContractPayrollLoan = require("../../components/contracts/contractPayrollLoan/contractPayrollLoan/contractPayrollLoan");
const { LoadingSection } = require('commonsComponents/loadingSection');
const LoansError = require('components/loansAndMortgages/loans/loansError/loansError');

//@core
const { formatText, getFinalTitle } = require("core/i18n").i18n;

// @ actions
const ContractPayrollLoanActions = require("../../actions/contractPayrollLoan");
const LoanRecordStatusActions = require("../../actions/loanRecordStatus");
const SegmentedLoanActions = require("../../actions/segmentedLoanProducts");
const blockedAccountsActions = require("actions/blockedAccounts");
const printedActions = require("actions/contactCenter/printer");
const mortgageRequestHolderConfirmation = require("actions/mortgageRequest/mortgageRequestHolderConfirmation");

const collectiveActions = require("actions/collectives");
const profileActions = require("actions/profile");
const preContractualMailInfoActions = require("actions/preContractualMailInfo");

class ContractPayrollLoanView extends React.Component {
    constructor(props) {
        super(props);

        this.setSelectedAccount = this.setSelectedAccount.bind(this);
        this.setVisibleStep = this.setVisibleStep.bind(this);
        this.validateStep = this.validateStep.bind(this);
    }

    componentWillUnmount() {
        const { resetBlockedAccounts } = this.props;
        resetBlockedAccounts();
    }

    setSelectedAccount(accountId) {
        const { setSelectedAccount } = this.props;
        if (accountId) {
            setSelectedAccount({ accountId });
        }
    }

    setVisibleStep(visibleStep) {
        const { setVisibleStep } = this.props;
        if (visibleStep) {
            setVisibleStep({ visibleStep });
        } else {
            setVisibleStep();
        }
    }

    validateStep(currentStep) {
        const { validateStep } = this.props;
        if (currentStep) {
            validateStep({ currentStep });
        } else {
            validateStep();
        }
    }

    buildBreadcrumbConfig() {
        return [
            {
                text: formatText("breadcrumb-loansAndMortgages"),
                url: "/myprofile/loans-mortgages",
            },
            {
                text: formatText("breadcrumb-payrollLoanContract"),
            },
        ];
    }

    buildContent() {
        const {
            cancelLoanRecord,
            contractInitialize,
            downloadINEDocument,
            downloadLoanContractDocument,
            formalize,
            getAsnefValidation,
            getBlockedAccounts,
            getCollectiveInfo,
            getHiringDocuments,
            getInstallment,
            getMinTerm,
            getProposition,
            hideNewOfferView,
            immAccounts,
            immFlagBasedFeatures,
            immCollectives,
            immPayrollLoan,
            immProfile,
            location,
            onDownloadDocument,
            onPrintDocument,
            preContractualMail,
            requestProfile,
            resetDocumentsAndAgreeCheckBox,
            resetPrecontractualMail,
            resetState,
            segmentedLoanProductsReset,
            sendMail,
            setAgree,
            setContractLoanAccountsInactive,
            setCurrentProductCollective,
            setLoanAmount,
            setLoanAmountNewOffer,
            setLoanTerm,
            setLoanTermNewOffer,
            setPaymentDay,
            printedAndSignedRadioChanged,
            enableButtonOffice,
            immPrinter,
            checkReadDocument,
            checkRadioButton,
            checkCheckedDocument
        } = this.props;

        return (
            <ContractPayrollLoan
                cancelLoanRecord={cancelLoanRecord}
                contractInitialize={contractInitialize}
                downloadINEDocument={downloadINEDocument}
                downloadLoanContractDocument={downloadLoanContractDocument}
                formalize={formalize}
                getAsnefValidation={getAsnefValidation}
                getBlockedAccounts={getBlockedAccounts}
                getCollectiveInfo={getCollectiveInfo}
                getHiringDocuments={getHiringDocuments}
                getInstallment={getInstallment}
                getMinTerm={getMinTerm}
                getProposition={getProposition}
                hideNewOfferView={hideNewOfferView}
                immAccounts={immAccounts}
                immFlagBasedFeatures={immFlagBasedFeatures}
                immCollectives={immCollectives}
                immContractPayrollLoan={immPayrollLoan}
                immProfile={immProfile}
                location={location}
                onDownloadDocument={onDownloadDocument}
                onPrintDocument={onPrintDocument}
                preContractualMail={preContractualMail}
                requestProfile={requestProfile}
                resetDocumentsAndAgreeCheckBox={resetDocumentsAndAgreeCheckBox}
                resetPrecontractualMail={resetPrecontractualMail}
                resetState={resetState}
                segmentedLoanProductsReset={segmentedLoanProductsReset}
                setCurrentProductCollective={setCurrentProductCollective}
                sendMail={sendMail}
                setAgree={setAgree}
                setContractLoanAccountsInactive={
                    setContractLoanAccountsInactive
                }
                setLoanAmount={setLoanAmount}
                setLoanAmountNewOffer={setLoanAmountNewOffer}
                setLoanTerm={setLoanTerm}
                setLoanTermNewOffer={setLoanTermNewOffer}
                setPaymentDay={setPaymentDay}
                setSelectedAccount={this.setSelectedAccount}
                setVisibleStep={this.setVisibleStep}
                validateStep={this.validateStep}
                printedAndSignedRadioChanged={printedAndSignedRadioChanged}
                enableButtonOffice={enableButtonOffice}
                immPrinter={immPrinter}
                checkReadDocument={checkReadDocument}
                checkRadioButton={checkRadioButton}
                checkCheckedDocument={checkCheckedDocument}
            />
        );
    }

    buildHeader() {
        const breadcrumb = this.buildBreadcrumbConfig();

        return (
            <OKCover
                size="medium"
                section="generic"
                customClass="contract-payroll-loan-view__header"
            >
                <OKHeaderSubPage
                    breadcrumbConfig={breadcrumb}
                    finalTitle={getFinalTitle(
                        "contractPayrollLoan-headerTitle"
                    )}
                />
            </OKCover>
        );
    }

    render() {
        const { hiringProductBanners } = this.props;
        const isAccountBlockedValidationFetching = hiringProductBanners.get('isAccountBlockedValidationFetching');
        const isAccountBlockedValidationError = hiringProductBanners.get('isAccountBlockedValidationError');
        const header = this.buildHeader();
        const content = this.buildContent();
        return (
            <>
                {
                    isAccountBlockedValidationFetching ?
                        <div className="contract-pre-granted-credit-view__loading"><LoadingSection /></div>
                        :
                        isAccountBlockedValidationError ?
                            <LoansError />
                            :
                            <article className="contract-payroll-loan-view">
                                {header}
                                <section className="contract-payroll-loan-view__body row">
                                    {content}
                                </section>
                            </article>
                }
            </>
        );
    }
}

ContractPayrollLoanView.propTypes = {
    cancelLoanRecord: PropTypes.func.isRequired,
    contractInitialize: PropTypes.func.isRequired,
    downloadINEDocument: PropTypes.func.isRequired,
    downloadLoanContractDocument: PropTypes.func.isRequired,
    formalize: PropTypes.func.isRequired,
    getAsnefValidation: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    getCollectiveInfo: PropTypes.func.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    getInstallment: PropTypes.func.isRequired,
    getMinTerm: PropTypes.func.isRequired,
    getProposition: PropTypes.func.isRequired,
    hideNewOfferView: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCollectives: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immPayrollLoan: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    location: PropTypes.object,
    onDownloadDocument: PropTypes.func.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func.isRequired,
    resetDocumentsAndAgreeCheckBox: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetState: PropTypes.func.isRequired,
    segmentedLoanProductsReset: PropTypes.func.isRequired,
    sendMail: PropTypes.func.isRequired,
    setAgree: PropTypes.func.isRequired,
    setContractLoanAccountsInactive: PropTypes.func.isRequired,
    setCurrentProductCollective: PropTypes.func.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setLoanAmountNewOffer: PropTypes.func.isRequired,
    setLoanTerm: PropTypes.func.isRequired,
    setLoanTermNewOffer: PropTypes.func.isRequired,
    setPaymentDay: PropTypes.func.isRequired,
    setSelectedAccount: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
};

module.exports = connect(
    (state) => ({
        //state mapping
        immAccounts: state.accounts,
        immCollectives: state.collectives,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immPayrollLoan: state.contractPayrollLoan,
        immProfile: state.profile,
        immPrinter: state.printer,
        preContractualMail: state.preContractualMail,
        hiringProductBanners: state.hiringProductBanners,

    }),
    {
        //actions mapping
        cancelLoanRecord: LoanRecordStatusActions.cancelLoanRecord,
        contractInitialize: ContractPayrollLoanActions.contractInitialize,
        downloadINEDocument: ContractPayrollLoanActions.downloadINEDocument,
        downloadLoanContractDocument:
            ContractPayrollLoanActions.downloadLoanContractDocument,
        formalize: ContractPayrollLoanActions.formalize,
        getAsnefValidation: ContractPayrollLoanActions.getAsnefValidation,
        getBlockedAccounts: blockedAccountsActions.getBlockedAccounts,
        getCollectiveInfo: collectiveActions.getCollectiveInfo,
        getHiringDocuments: ContractPayrollLoanActions.getHiringDocuments,
        getInstallment: ContractPayrollLoanActions.getInstallment,
        getMinTerm: ContractPayrollLoanActions.getMinTerm,
        getProposition: ContractPayrollLoanActions.getProposition,
        hideNewOfferView: ContractPayrollLoanActions.hideNewOfferView,
        onDownloadDocument: ContractPayrollLoanActions.onDownloadDocument,
        onPrintDocument: ContractPayrollLoanActions.onPrintDocument,
        requestProfile: profileActions.requestProfile,
        resetBlockedAccounts: blockedAccountsActions.resetBlockedAccounts,
        resetDocumentsAndAgreeCheckBox:
            ContractPayrollLoanActions.simpleActions
                .contractPayrollLoanResetDocumentAndAgreeCheckbox,
        resetPrecontractualMail:
            preContractualMailInfoActions.resetPrecontractualMail,
        resetState:
            ContractPayrollLoanActions.simpleActions
                .contractPayrollLoanResetState,
        segmentedLoanProductsReset:
            SegmentedLoanActions.simpleActions.segmentedLoanProductsReset,
        setCurrentProductCollective:
            ContractPayrollLoanActions.simpleActions
                .contractPayrollLoanSetCollective,
        sendMail: preContractualMailInfoActions.sendLoanPreContractualMail,
        setAgree:
            ContractPayrollLoanActions.simpleActions
                .contractPayrollLoanSetAgree,
        setContractLoanAccountsInactive:
            ContractPayrollLoanActions.simpleActions
                .contractPayrollLoanSetInactiveAccount,
        setLoanAmount:
            ContractPayrollLoanActions.simpleActions
                .contractPayrollLoanSetLoanAmount,
        setLoanAmountNewOffer: ContractPayrollLoanActions.setLoanAmountNewOffer,
        setLoanTerm:
            ContractPayrollLoanActions.simpleActions.contractPayrollLoanSetTerm,
        setLoanTermNewOffer: ContractPayrollLoanActions.setLoanTermNewOffer,
        setPaymentDay:
            ContractPayrollLoanActions.simpleActions
                .contractPayrollLoanSetPaymentDay,
        setSelectedAccount:
            ContractPayrollLoanActions.simpleActions
                .contractPayrollLoanSetAccount,
        setVisibleStep:
            ContractPayrollLoanActions.simpleActions
                .contractPayrollLoanSetVisibleStep,
        validateStep: ContractPayrollLoanActions.validateStep,
        printedAndSignedRadioChanged: printedActions.printedAndSignedRadioChanged,
        enableButtonOffice: mortgageRequestHolderConfirmation.enableButtonOffice,
        checkReadDocument: ContractPayrollLoanActions.checkReadDocument,
        checkRadioButton: ContractPayrollLoanActions.checkRadioButton,
        checkCheckedDocument: ContractPayrollLoanActions.checkCheckedDocument

    }
)(ContractPayrollLoanView);
